import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogIn, FiX, FiChevronDown } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../utils/CONSTANTS';
import axios from 'axios';

const predefinedUsers = {
  admin: { username: "admin", password: "admin" },
  packer: { username: "packer", password: "packer" },
  qc: { username: "qc", password: "qc" },
  user: { username: "user", password: "user" }
};

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userType, setUserType] = useState('');
  const navigate = useNavigate();

  const handleLogin = async(e) => {
    e.preventDefault();

    if (!username || !password || !userType) {
      toast.error("Please fill all fields", { position: "top-right", autoClose: 3000 });
      return;
    }

    

    const response  = await axios.post(
      `${API_BASE_URL}/api/login`,
      { 
        withCredentials: true,
        email:username,
        password,
        role:userType
      },
      {
        headers: {
        // Authorization: `Bearer ${token}`,
        'Content-Type': "application/json",
        }
      }
    );
    console.log(response)

    if (!response.data.success) {
      alert("Please check your credentials");
      return;
    }

    if (response.data.success) {
      toast.success("Logged in successfully!", { position: "top-right", autoClose: 3000 });
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("userRole", userType);
      localStorage.setItem("username",username)
      navigate("/dashboard");
    } else {
      alert("Please check your credentials");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-100 to-white flex flex-col">
      <header className="bg-blue-600 text-white shadow-lg">
        <div className="container mx-auto px-4 py-4">
          <h1 className="text-xl md:text-2xl font-bold">GST - Business Management System</h1>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 py-8 flex items-center justify-center">
        <div className="w-full max-w-md">
          <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
            <div className="p-8">
              <form onSubmit={handleLogin} className="space-y-6">
                <div>
                  <label htmlFor="userType" className="block text-sm font-medium text-gray-700">Login as</label>
                  <div className="relative mt-1">
                    <select
                      id="userType"
                      value={userType}
                      onChange={(e) => setUserType(e.target.value)}
                      className="block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm shadow-sm focus:outline-none focus:border-blue-500"
                    >
                      <option value="">Select user type</option>
                      <option value="superadmin">Super Admin</option>
                      <option value="admin">Admin</option>
                      <option value="packer">Packer</option>
                      <option value="qc">QC</option>
                      <option value="user">User</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <FiChevronDown className="h-4 w-4" />
                    </div>
                  </div>
                </div>

                <div>
                  <label htmlFor="username" className="block text-sm font-medium text-gray-700">Username</label>
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500"
                  />
                </div>

                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500"
                  />
                </div>

                <div className="flex justify-end space-x-4">
                  <button
                    type="submit"
                    className="flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <FiLogIn className="mr-2" />
                    Login
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setUsername('');
                      setPassword('');
                      setUserType('');
                    }}
                    className="flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <FiX className="mr-2" />
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Login;
